import type { SVGProps } from 'react';

export const ArrowButton = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="10px"
    role="img"
    viewBox="0 0 32 10"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'arrow button'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(0.000000, -11.000000)">
        <rect height="32" width="32" x="0" y="0" />
        <g fill={props.fill} transform="translate(0.000000, 11.076099)">
          <polygon points="0 5.9239006 25.0142441 5.9239006 25.0142441 9.95986366 32 4.9239006 25.0142441 6.21715433e-16 25.0142441 3.9239006 0 3.9239006" />
        </g>
      </g>
    </g>
  </svg>
);
